import React from "react";
import "./MinnesotaPartnership.css";
import MnLogo from "../assets/logo5.png"; 

// 6 Active Pilots
const districts = [
  { id: 1, name: "Minnetonka Public Schools", status: "Active Pilot" },
  { id: 2, name: "Edina Public Schools", status: "Active Pilot" },
  { id: 3, name: "Wayzata Public Schools", status: "Active Pilot" },
  { id: 4, name: "Rochester Public Schools", status: "Active Pilot" },
  { id: 5, name: "Anoka-Hennepin Schools", status: "Active Pilot" },
  { id: 6, name: "Osseo Area Schools", status: "Active Pilot" },
];

export default function MinnesotaPartnership() {
  return (
    <main className="mn-page">
      {/* Shift wrapper */}
      <div className="mn-shift">
        
        {/* Decorative lines overlay */}
        <div className="mn-lines" aria-hidden="true">
          <span className="mn-line v v1" />
          <span className="mn-line v v2" />
          <span className="mn-line h h1" />
          <span className="mn-line h h2" />
        </div>

        {/* Hero / Initiative Context */}
        <section className="mn-hero">
          <div className="mn-shell">
            <div className="mn-hero-copy">
              
              {/* Dual Logo Header */}
              <div className="mn-partner-header">
                <span className="mn-pill">Official Launch • 2026 Pilot</span>
                
                {/* Clickable Logo */}
                <a 
                  href="https://minnesotaachievement.org/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="mn-partner-link"
                >
                  <img src={MnLogo} alt="Minnesota Achievement" className="mn-partner-logo-img" />
                </a>

              </div>

              {/* Title */}
              <h1 className="mn-title">
                Bringing AI-powered transparency<br />
                to <span className="mn-title-accent">Minnesota schools.</span>
              </h1>

              <p className="mn-subtitle">
                BoardWatch is proud to announce our expansion into Minnesota in partnership with 
                the <strong>Minnesota Partnership for Achievement</strong>. Together, we are deploying 
                automated governance tracking to help parents and communities stay informed.
              </p>

              {/* Content Block */}
              <div className="mn-mission">
                <h2 className="mn-section-kicker">The Initiative</h2>
                <div className="mn-mission-content">
                  <p>
                    Minnesota parents care deeply about their local schools but often lack the time to watch four-hour board meetings. The sheer volume of video footage created every month makes it nearly impossible for working families to stay informed. This disconnect leaves communities in the dark about critical votes on budgets, curriculum, and policy.
                  </p>
                  <p>
                    To bridge this gap, BoardWatch has entered a strategic partnership with Cristine Trooien and the Minnesota Partnership for Achievement (MPA). MPA is not just advocating for transparency but actively investing in it. By sponsoring this pilot, MPA is directly equipping their members with BoardWatch monitoring tools. This launch serves as the foundation for a statewide rollout and creates a scalable model to provide affordable coverage to parent groups across the entire network.
                  </p>
                  <p>
                    This pilot program leverages BoardWatch’s AI engine to automatically transcribe and summarize school board meetings for six key districts. We believe that transparency should not be a full-time job. Our technology generates summaries that link directly to the video source so parents can verify facts instantly. This launch represents a new chapter in local governance where technology helps families engage with their district leaders from a place of knowledge rather than confusion.
                  </p>
                </div>
              </div>

              {/* --- METRICS SECTION --- */}
              <div className="mn-principles">
                <div className="mn-principle">
                  <div className="mn-principle-title" style={{ fontSize: '28px', color: 'var(--bw-blue)', marginBottom: '4px' }}>6</div>
                  <div className="mn-principle-title">Districts Covered</div>
                  <p className="mn-principle-text">
                    Launching with a focused cohort of Minnesota school boards.
                  </p>
                </div>

                <div className="mn-principle">
                  <div className="mn-principle-title" style={{ fontSize: '28px', color: 'var(--bw-blue)', marginBottom: '4px' }}>100+</div>
                  <div className="mn-principle-title">Meetings Summarized</div>
                  <p className="mn-principle-text">
                     Automatically capturing every agenda item, vote, and public comment.
                  </p>
                </div>

                <div className="mn-principle">
                  <div className="mn-principle-title" style={{ fontSize: '28px', color: 'var(--bw-blue)', marginBottom: '4px' }}>500+</div>
                  <div className="mn-principle-title">Hours Saved</div>
                  <p className="mn-principle-text">
                    Time returned to parents who no longer have to sift raw footage to be informed.
                  </p>
                </div>
              </div>

            </div>
          </div>
        </section>

        {/* Participating Districts List */}
        <section className="mn-districts">
          <div className="mn-shell">
            <div className="mn-districts-header">
              <h2 className="mn-districts-title">Minnesota Districts Covered</h2>
              <div className="mn-districts-underline" />
              <p className="mn-districts-sub">
                The following districts have been selected for the initial launch.
              </p>
            </div>

            <div className="mn-districts-grid">
              {districts.map((d) => (
                <article className="district-card" key={d.id}>
                  <div className="district-meta">
                    <div className="district-status">{d.status}</div>
                    <div className="district-name">{d.name}</div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

      </div>
    </main>
  );
}